// extracted by mini-css-extract-plugin
export default {"lastEditInfoContainer":"MarkdownLastEditedBy-module__lastEditInfoContainer__zi8GuG4","mutedEditorLink":"MarkdownLastEditedBy-module__mutedEditorLink__YCjyfH9"};